import { useRecoilCallback } from 'recoil';
import {
    clearAnnotations,
    hoveredAnnotationState,
    selectedAnnotationState,
} from '~/state/atoms/annotationListAtoms';
import { viewManagerState } from '~/state/atoms/engineAtoms';
import { profileHoverState } from '~/state/atoms/intensityToolAtoms';
import {
    MEASURE_ANNOTATION_LISTS,
    MEASURE_DRAFT_STATES,
} from '~/state/atoms/measurementAtoms';

/**
 * Returns a callback that removes every shape, draft, selection and hover:
 * each holds values read from one patient's image, so none may outlive that
 * patient. The mode, shape, family and pin preferences are kept.
 */
export function useClearAnnotations(): () => void {
    return useRecoilCallback(
        (callback) => () => {
            // A draft outliving its list would commit into the empty one.
            callback.snapshot
                .getLoadable(viewManagerState)
                .getValue()
                ?.interactionContext.toolManager.cancelActivePlacementDraft();
            for (const list of MEASURE_ANNOTATION_LISTS) {
                clearAnnotations(callback, list);
            }
            for (const state of [
                ...MEASURE_DRAFT_STATES,
                selectedAnnotationState,
                hoveredAnnotationState,
                profileHoverState,
            ]) {
                callback.reset(state);
            }
        },
        []
    );
}
